import { TransactionType } from "@gtpl/shared-models/common-models";
import { ForkLiftJobDTO, ForkLiftJobStatus } from "../fork-lift-job";


export class ForkLiftJob {
    jobId: number;
    jobCode: string;
    transactionTime: Date;
    status: ForkLiftJobStatus;
    reportedId: number;
    transactionType: TransactionType;
    createdUser: string;
    plantId: number;
    lotCode?: string;
    updatedUser?: string;
    totalJobCartons?: number;
    forkLiftItemsInfo: ForkLiftItemsReq[];
    totalIssuedQuantity?: number;
    totalReceivedQuantity?: number;
    damagedQuantity?: number;
    excessQuantity?: number;
    fromPlantId?: number;
    toPlantId?: number;
    jobPurpose?: string;
    totalJobLoosePouches?: number;


    
   
    constructor(jobId: number,
    jobCode: string,
    transactionTime: Date,
    status: ForkLiftJobStatus,
    reportedId: number,
    transactionType: TransactionType,
    forkLiftItemsInfo: ForkLiftItemsReq[], createdUser: string, plantId: number,lotCode: string,
    updatedUser?: string,totalJobCartons?: number,totalIssuedQuantity?: number,totalReceivedQuantity?: number,damagedQuantity?: number,excessQuantity?: number,fromPlantId?: number,
    toPlantId?: number,jobPurpose?: string,totalJobLoosePouches?: number){
        this.jobId= jobId;
        this.jobCode= jobCode;
        this.transactionTime= transactionTime;
        this.status= status;
        this.reportedId= reportedId;
        this.transactionType= transactionType;
        this.forkLiftItemsInfo= forkLiftItemsInfo;
        this.createdUser = createdUser;
        this.plantId = plantId;
        this.lotCode =  lotCode;
        this.updatedUser =  updatedUser;
        this.totalJobCartons =  totalJobCartons;
        this.totalIssuedQuantity =  totalIssuedQuantity;
        this.totalReceivedQuantity =  totalReceivedQuantity;
        this.damagedQuantity =  damagedQuantity;
        this.excessQuantity =  excessQuantity;
        this.fromPlantId =  fromPlantId;
        this.toPlantId =  toPlantId;
        this.jobPurpose =  jobPurpose;
        this.totalJobLoosePouches = totalJobLoosePouches
    }
}

export class ForkLiftItemsReq {
    saleOrderId: number;
    saleOrderItemId: number;
    pallet: number;
    currentPosition: number;
    targetPosition: number;
    realPosition: number;
    date: Date;
    createdUser: string;
    updatedUser: string;
    createdAt: Date;
    updatedAt: Date;
    syncStatus?: boolean;
    versionFlag: number;
    forkLiftItemId: number;
    jobCartons?: number;
    forkLiftJobInfo?: ForkLiftJobDTO;
    issuedQuantity?: number;
    receivedQuantity?: number;
    stockId?: number;
    unitId?: number;
    jobLoosePouches?: number;
    selectedVariantId?: number;
    domesticSaleId?:number
    constructor(
        saleOrderId: number,
        saleOrderItemId: number,
        pallet: number,
        currentPosition: number,
        targetPosition: number,
        realPosition: number,
        date: Date,
        createdUser: string,
        updatedUser: string,
        createdAt: Date,
        updatedAt: Date,
        syncStatus?: boolean,
        versionFlag?: number,
        forkLiftItemId?: number,
        jobCartons?: number,
        forkLiftJobInfo?: ForkLiftJobDTO,
        issuedQuantity?: number,
        receivedQuantity?: number,
        stockId?: number,
        unitId?: number,
        jobLoosePouches?: number,
        selectedVariantId?: number,
        domesticSaleId?:number

    ){
        this.saleOrderId= saleOrderId;
        this.saleOrderItemId= saleOrderItemId;
        this.pallet= pallet;
        this.currentPosition= currentPosition;
        this.targetPosition= targetPosition;
        this.realPosition= realPosition;
        this.date= date;
        this.createdUser = createdUser;
        this.createdAt = createdAt;
        this.updatedAt =  updatedAt;
        this.updatedUser =  updatedUser;
        this.syncStatus =  syncStatus;
        this.versionFlag =  versionFlag;
        this.forkLiftItemId =  forkLiftItemId;
        this.jobCartons =  jobCartons;
        this.forkLiftJobInfo =  forkLiftJobInfo;
        this.issuedQuantity =  issuedQuantity;
        this.receivedQuantity =  receivedQuantity;
        this.stockId =  stockId;
        this.unitId = unitId
        this.jobLoosePouches =  jobLoosePouches;
        this.selectedVariantId = selectedVariantId
        this.domesticSaleId=domesticSaleId
    }
} 
